import { render, staticRenderFns } from "./DisableableAutoResizeTextarea.vue?vue&type=template&id=0cc7dc91&scoped=true&"
import script from "./DisableableAutoResizeTextarea.vue?vue&type=script&lang=ts&"
export * from "./DisableableAutoResizeTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./DisableableAutoResizeTextarea.vue?vue&type=style&index=0&id=0cc7dc91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc7dc91",
  null
  
)

export default component.exports